import { AuthService } from './../auth.service';
import { Observable } from 'rxjs';
import { Itinerary } from './../itineray.model';
import { ItineraryService } from './../itinerary.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-home',
  templateUrl: './customer-home.component.html',
  styleUrls: ['./customer-home.component.css']
})
export class CustomerHomeComponent implements OnInit {

  itineraries$: Observable<Itinerary[]>;

  constructor(private itineraryService: ItineraryService, private authService: AuthService) { }

  ngOnInit() {
    this.itineraries$ = this.itineraryService.listForCustomer(this.authService.user);
  }

}
